import React from 'react'

const Completion = () => {
  return (
    <svg
          width="210"
          height="170"
          viewBox="-15 0 203 151"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="primary-svg-stroke overflow-visible"
        >
          {/* Circle draws first */}
          <path
            className="draw-circle"
            d="M94 137.5C128.375 137.5 156.5 109.375 156.5 75C156.5 40.625 128.375 12.5 94 12.5C59.625 12.5 31.5 40.625 31.5 75C31.5 109.375 59.625 137.5 94 137.5Z"
            stroke="#FE5900"
            strokeWidth="9.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Tick draws second */}
          <path
            className="draw-tick"
            d="M67.4375 75L85.125 92.6875L120.562 57.3125"
            stroke="#FE5900"
            strokeWidth="9.375"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {/* Sparkles (same as before) */}
          <path
            className="sparkle-animate"
            style={{ animationDelay: "0s" }}
            d="M17 117L20.1855 130.814L34 134L20.1855 137.186L17 151L13.8145 137.186L0 134L13.8145 130.814L17 117Z"
            fill="#FFDE4D"
          />
          <path
            className="sparkle-animate"
            style={{ animationDelay: "0.3s" }}
            d="M35 5.5L37.3423 15.6577L47.5 18L37.3423 20.3423L35 30.5L32.6577 20.3423L22.5 18L32.6577 15.6577L35 5.5Z"
            fill="#FFDE4D"
          />
          <path
            className="sparkle-animate"
            style={{ animationDelay: "0.6s" }}
            d="M165 34.5L166.405 40.5946L172.5 42L166.405 43.4054L165 49.5L163.595 43.4054L157.5 42L163.595 40.5946L165 34.5Z"
            fill="#FFDE4D"
          />
        </svg>
  )
}

export default Completion